import { DefaultService } from '../../common/services/DefaultService';
import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import {
    AccountConfirmModel, AccountPhoneModel, ChangePasswordModel, EmailForgotPasswordModel,
    LoginModel, ResetPasswordModel, SignupModel, TokenResource
} from '../models/AccountTypes';

export class AccountService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/account`

    public RouteLogout = () => `${this.baseUrl}/logout`;
    public logout(): JQueryPromise<any> {
        return $.ajax(this.RouteLogout(), {
            type: 'get',
            contentType: 'text/html; charset=utf-8'
        });
    }

    public RouteLogin = () => `${this.baseUrl}/login`;
    public login(model: LoginModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteLogin(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSignup = () => `${this.baseUrl}/signup`;
    public signup(model: SignupModel): JQueryPromise<any> {
        //result: AccountModel
        return $.ajax(this.RouteSignup(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteResetPassword = () => `${this.baseUrl}/resetPassword`;
    public resetPassword(model: ResetPasswordModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteResetPassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteChangePassword = () => `${this.baseUrl}/changePassword`;
    public changePassword(model: ChangePasswordModel): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteChangePassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteUpdateFcmToken = () => `${this.baseUrl}/updateFcmToken`;
    public updateFcmToken(model: TokenResource): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteUpdateFcmToken(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteUpdateFcmTokenForGuest = () => `${this.baseUrl}/updateFcmTokenForGuest`;
    public updateFcmTokenForGuest(model: TokenResource): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteUpdateFcmTokenForGuest(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSubscribeNotificationTopic = () => `${this.baseUrl}/subscribeNotificationTopic`;
    public subscribeNotificationTopic(model: TokenResource): JQueryPromise<any> {
        //result: boolean
        return $.ajax(this.RouteSubscribeNotificationTopic(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}

export class AccountByService extends DefaultService {
    private baseUrl: string;

    constructor(isByEmail: boolean) {
        super();

        const controller = isByEmail ? "accountByEmail" : "accountByPhone";
        this.baseUrl = `${apiBaseUrlUser}/${controller}`;
    }

    public RouteSendConfirmCode = (userId: string) => `${this.baseUrl}/SendConfirmCode/${userId}`;
    public SendConfirmCode(userId: string): JQueryPromise<any> {
        //result: string
        return $.ajax(this.RouteSendConfirmCode(userId), {
            type: 'post',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteConfirm = () => `${this.baseUrl}/confirm`;
    public confirm(model: AccountConfirmModel): JQueryPromise<any> {
        //result: AuthTokenInfo
        return $.ajax(this.RouteConfirm(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteSendForgotPasswordCode = (userId: string) => `${this.baseUrl}/sendForgotPasswordCode/${userId}`;
    public sendForgotPasswordCode(userId: string): JQueryPromise<any> {
        //result: string
        alert(this.RouteSendForgotPasswordCode(userId));
        return $.ajax(this.RouteSendForgotPasswordCode(userId), {
            type: 'post',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteConfirmForgotPassword = () => `${this.baseUrl}/confirmForgotPassword`;
    public confirmForgotPassword(model: AccountConfirmModel): JQueryPromise<any> {
        //result: ResetPasswordModel
        return $.ajax(this.RouteConfirmForgotPassword(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetUserForConfirm = () => `${this.baseUrl}/getUserForConfirm`;
    public getUserForConfirm(model: AccountPhoneModel | EmailForgotPasswordModel): JQueryPromise<any> {
        //result: AccountModel
        return $.ajax(this.RouteGetUserForConfirm(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}

//export interface Customer {
//    id: number;
//    firstName: string;
//    lastName: string;
//}

//export interface ICustomerRepository {
//    getAll(): Promise<Customer[]>;
//    create(input: Omit<Customer, "id">): Promise<ExtendedAuthTokensInfo>;
//}

//export class GetCustomers {
//    constructor(private repository: ICustomerRepository) { }

//    async execute(): Promise<Customer[]> {
//        return await this.repository.getAll();
//    }
//}

//export interface CreateCustomerInput {
//    firstName: string;
//    lastName: string;
//}

//export class CreateCustomer {
//    constructor(private repository: ICustomerRepository) { }

//    async execute(input: CreateCustomerInput): Promise<ExtendedAuthTokensInfo> {
//        if (!input.firstName.trim()) {
//            throw new Error("First name is required.");
//        }

//        if (!input.lastName.trim()) {
//            throw new Error("Last name is required.");
//        }

//        return await this.repository.create(input);
//    }
//}

//export async function http<T>(url: string, options?: RequestInit): Promise<T> {
//    const response = await fetch(url, {
//        headers: {
//            "Content-Type": "application/json",
//            ...(options?.headers || {})
//        },
//        ...options
//    });

//    if (!response.ok) {
//        const message = await response.text();
//        throw new Error(message || "Request failed.");
//    }

//    return response.json() as Promise<T>;
//}

//const baseUrl = "/api/customers";

//export const customerApi = {
//    getAll: () => http<Customer[]>(baseUrl),

//    create: (input: Omit<Customer, "id">) =>
//        http<ExtendedAuthTokensInfo>(baseUrl, {
//            method: "POST",
//            body: JSON.stringify(input)
//        })
//};
//export class CustomerRepository implements ICustomerRepository {
//    async getAll(): Promise<Customer[]> {
//        return await customerApi.getAll();
//    }

//    async create(input: Omit<Customer, "id">): Promise<ExtendedAuthTokensInfo> {
//        return await customerApi.create(input);
//    }
//}

//export function useCustomerViewModel() {
//    const repository = useMemo(() => new CustomerRepository(), []);
//    const getCustomers = useMemo(() => new GetCustomers(repository), [repository]);
//    const createCustomer = useMemo(() => new CreateCustomer(repository), [repository]);

//    const [customers, setCustomers] = useState<Customer[]>([]);
//    const [firstName, setFirstName] = useState("");
//    const [lastName, setLastName] = useState("");
//    const [loading, setLoading] = useState(false);
//    const [saving, setSaving] = useState(false);
//    const [error, setError] = useState("");

//    const load = async () => {
//        try {
//            setLoading(true);
//            setError("");

//            const data = await getCustomers.execute();
//            setCustomers(data);
//        } catch (err) {
//            setError(err instanceof Error ? err.message : "Failed to load customers.");
//        } finally {
//            setLoading(false);
//        }
//    };

//    const create = async () => {
//        try {
//            setSaving(true);
//            setError("");

//            const created = await createCustomer.execute({
//                firstName,
//                lastName
//            });

//            setCustomers(prev => [...prev, created]);
//            setFirstName("");
//            setLastName("");
//        } catch (err) {
//            setError(err instanceof Error ? err.message : "Failed to create customer.");
//        } finally {
//            setSaving(false);
//        }
//    };

//    return {
//        customers,
//        firstName,
//        lastName,
//        loading,
//        saving,
//        error,
//        setFirstName,
//        setLastName,
//        load,
//        create
//    };
//}

//function useMemo(arg0: () => CustomerRepository, arg1: never[]) {
//    throw new Error('Function not implemented.');
//}

//function useState<T>(arg0: never[]): [any, any] {
//    throw new Error('Function not implemented.');
//}